import { Button } from '@/General/Button'
import { ErrorBox } from '@/General/Forms/ErrorBox'
import { Input } from '@/General/Forms/Input'
import { ProductThumbnail } from '@/General/ProductThumbnail'

type ExplanationAccessCodeFormProps = {
  heading?: string
  title: string
  thumbnailAlt?: string
  thumbnailSrc?: string | null
  errors: string[]
  isSubmitting: boolean
  submitLabel: string
  inputPlaceholder?: string
  onSubmit: React.FormEventHandler<HTMLFormElement>
  inputProps?: React.InputHTMLAttributes<HTMLInputElement>
}

export const ExplanationAccessCodeForm = ({
  heading = 'Access your explanation',
  title,
  thumbnailAlt = 'Explanation video thumbnail',
  thumbnailSrc,
  errors,
  isSubmitting,
  submitLabel,
  inputPlaceholder = 'Enter password',
  onSubmit,
  inputProps,
}: ExplanationAccessCodeFormProps) => {
  const hasThumbnail = Boolean(thumbnailSrc?.trim())

  return (
    <div
      className={`w-full mx-auto overflow-hidden rounded-lg border border-gray-200 bg-white shadow-sm ${
        hasThumbnail ? 'max-w-xl' : 'max-w-md'
      }`}
    >
      {hasThumbnail && (
        <div className="relative aspect-video bg-gray-100">
          <ProductThumbnail
            src={thumbnailSrc}
            alt={thumbnailAlt}
            className="h-full w-full object-cover"
          />
        </div>
      )}

      <div className="p-6 text-center sm:p-8">
        <h1 className="text-2xl font-semibold leading-tight text-gray-950">
          {heading}
        </h1>
        <div
          className="mt-3 text-base font-medium leading-relaxed text-gray-700 [&_a]:text-green-700 [&_a]:underline [&_a:hover]:no-underline"
          dangerouslySetInnerHTML={{ __html: title }}
        />

        <form onSubmit={onSubmit} className="mt-6 space-y-4" noValidate>
          <ErrorBox errors={errors} />

          <Input
            id="explanation-access-code"
            type="text"
            placeholder={inputPlaceholder}
            autoComplete="off"
            isError={errors.length > 0}
            {...(inputProps ?? {})}
          />

          <Button
            type="submit"
            color="green"
            size="md"
            disabled={isSubmitting}
            className="w-full"
          >
            {submitLabel}
          </Button>
        </form>
      </div>
    </div>
  )
}
